module.exports = __webpack_public_path__ + "static/media/contacto_new.636db397.jpg";